















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class AddEmail extends Vue {
  onAddEmail() {
    this.$store.commit("ADD_EMAIL_CLICK");
  }
}
